import { createAuthThunks, createAuthSlice } from '@amzn/d2c-application-website-common';
import { RoadieService } from 'src/services/roadie';
import { awsRum } from 'src/rum';

// Create thunks with Burberry's RoadieService and CW RUM logging
const thunks = createAuthThunks(
  (_stage: string, csrfToken?: string) => new RoadieService(csrfToken),
  {
    error: (message, context) => {
      awsRum?.recordEvent('AuthError', { message, ...context });
    },
    recordAPIError: (site, api, status) => {
      awsRum?.recordEvent('APIError', { site, api, status });
    },
    recordAPIRequest: (site, api) => {
      awsRum?.recordEvent('APIRequest', { site, api });
    },
  },
);

export const { getValidateToken, getClientId, logOut } = thunks;

const authSlice = createAuthSlice(thunks);

export const {
  setAuthState,
  replaceAuthState,
  updateExpiryTime,
  updateCsrfToken,
  clearAuthState,
  setAuthInProgress,
} = authSlice.actions;

export default authSlice.reducer;

// Re-export selectors from common
export {
  selectAuthState,
  selectExpiryTime,
  selectValidateTokenInProgress,
  selectValidateTokenComplete,
  selectValidateTokenError,
  selectGetClientIdError,
  selectLogOutError,
  selectLogOutSuccess,
  selectClientId,
  selectCsrfToken,
} from '@amzn/d2c-application-website-common';
